<div class="floating-bubble">
    <div class="block"></div>
    <div class="content"><ng-content></ng-content></div>
</div>
